<template>
  <div v-if="api_data.Farmer" class="card rounded-0 card-custom gutter-b">
    <div class="card-header border-0 pt-5">
      <div class="card-title">
        <div class="card-label">
          <router-link class="btn btn-info btn-xs"
                       style="margin: 2px"
                       :to="{ name: 'farmer-edit', params: { id: api_data.Farmer.id }}">
            {{ $t("Edit") }} {{ $t("Account Information") }}
          </router-link>
          <router-link class="btn btn-default btn-xs"
                       :to="{ name: 'farmer'}">
            {{ $t("Back") }}
          </router-link>
          <span class="text-muted mt-3 font-weight-bold font-size-sm"></span>
        </div>
      </div>
    </div>
    <div class="card-body pt-2">
      <div class="d-flex flex-grow-1 align-items-center bg-hover-light p-4 rounded"
           v-if="api_data.Farmer.basic_account_holder_whatsapp"
      >
        <div class="mr-4 flex-shrink-0 text-center" style="width: 40px;">
          <i class="icon-xl fab fa-whatsapp"></i>
        </div>
        <div class="text-muted">{{ api_data.Farmer.basic_account_holder_whatsapp }}</div>
      </div>
      <div class="d-flex flex-grow-1 align-items-center bg-hover-light p-4 rounded"
           v-if="api_data.Farmer.basic_account_holder_mobile"
      >
        <div class="mr-4 flex-shrink-0 text-center" style="width: 40px;">
          <i class="icon-xl fas fa-mobile-alt"></i>
        </div>
        <div class="text-muted">{{ api_data.Farmer.basic_account_holder_mobile }}</div>
      </div>
      <label-text
          v-bind:text="api_data.Farmer.account_holder_organization"
          v-bind:label="'Organization'"
      ></label-text>
      <label-text
          v-bind:text="api_data.Farmer.basic_account_holder"
          v-bind:label="'Name'"
          v-bind:bg_class="'bg-info'"
      ></label-text>
      <label-text
          v-bind:text="api_data.Farmer.basic_account_holder_surname"
          v-bind:label="'Surname'"
          v-bind:bg_class="'bg-info'"
      ></label-text>
      <label-text
          v-bind:text="api_data.Farmer.basic_account_holder_gender"
          v-bind:label="'Gender'"
          v-bind:bg_class="'bg-info'"
      ></label-text>
      <label-text
          v-bind:text="api_data.Farmer.basic_account_holder_husband"
          v-bind:label="'Husband'"
          v-bind:bg_class="'bg-info'"
      ></label-text>
      <label-text
          v-bind:text="api_data.Farmer.basic_account_holder_wife"
          v-bind:label="'Wife'"
          v-bind:bg_class="'bg-info'"
      ></label-text>
      <label-text
          v-bind:text="api_data.Farmer.basic_account_holder_address"
          v-bind:label="'Address'"
          v-bind:bg_class="'bg-info'"
      ></label-text>
      <label-text
          v-bind:text="api_data.Farmer.basic_account_holder_village"
          v-bind:label="'Village'"
          v-bind:bg_class="'bg-info'"
      ></label-text>
      <label-text
          v-bind:text="api_data.Farmer.basic_account_holder_panchayat"
          v-bind:label="'Panchayat'"
          v-bind:bg_class="'bg-info'"
      ></label-text>
      <label-text
          v-bind:text="api_data.Farmer.basic_account_holder_taluko"
          v-bind:label="'Taluko'"
          v-bind:bg_class="'bg-info'"
      ></label-text>
      <label-text
          v-bind:text="api_data.Farmer.basic_account_holder_district"
          v-bind:label="'District'"
          v-bind:bg_class="'bg-info'"
      ></label-text>
      <label-text
          v-bind:text="api_data.Farmer.basic_account_holder_marriage_status"
          v-bind:label="'Marriage'"
          v-bind:bg_class="'bg-info'"
      ></label-text>
      <label-text
          v-bind:text="api_data.Farmer.basic_account_holder_brother"
          v-bind:label="'Brother'"
          v-bind:bg_class="'bg-info'"
      ></label-text>
      <label-text
          v-bind:text="api_data.Farmer.basic_account_holder_brother_marriage_status"
          v-bind:label="'Brother Marriage'"
          v-bind:bg_class="'bg-info'"
      ></label-text>
      <label-text
          v-bind:text="api_data.Farmer.basic_account_holder_sister"
          v-bind:label="'Sister'"
          v-bind:bg_class="'bg-info'"
      ></label-text>
      <label-text
          v-bind:text="api_data.Farmer.basic_account_holder_sister_marriage_status"
          v-bind:label="'Sister Marriage'"
          v-bind:bg_class="'bg-info'"
      ></label-text>
    </div>
  </div>
</template>

<script>
import labelText from '../labelText'
import titleHead from '../titleHead'

export default {
  name: 'show-basic-information',
  component: [
    labelText,
    titleHead
  ],
  props: {
    api_data: Object,
  }
}
</script>
